import type {ReactElement} from 'react';
import {ControlledListItemType7} from '@Components/controlled-list/components/controlled-list-item-type-7';
import type {ActionMenuProps} from './action-menu.types';
import styles from './action-menu.module.scss';

// Own row loop rather than ControlledList: its type-7 mapping drops textSuffixElement and isLoading, and it wraps rows in a <ul>.
export function ActionMenu({items, isMobile, infoNote}: ActionMenuProps): ReactElement {
  const getRows = (): ReactElement[] => {
    return items.map((item) => (
      <ControlledListItemType7
        key={item.id}
        id={item.id}
        icon={item.icon}
        color={item.color}
        textSuffixElement={item.textSuffixElement}
        text={item.text}
        onClick={item.onClick}
        isLoading={item.isLoading}
        isDisabled={item.isDisabled}
        tooltip={item.tooltip}
        textClasses={item.textClasses}
        iconClasses={item.iconClasses}
        className="radius-8"
        customElement={item.customElement}
      />
    ));
  };

  if (isMobile) {
    return (
      <>
        {getRows()}
        {infoNote}
      </>
    );
  }

  return (
    <div className={styles.container}>
      {getRows()}
      {infoNote}
    </div>
  );
}
